import { render, staticRenderFns } from "./InfiniteCanvasView.vue?vue&type=template&id=ede7e1f8&scoped=true"
import script from "./InfiniteCanvasView.vue?vue&type=script&lang=js"
export * from "./InfiniteCanvasView.vue?vue&type=script&lang=js"
import style0 from "./InfiniteCanvasView.vue?vue&type=style&index=0&id=ede7e1f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede7e1f8",
  null
  
)

export default component.exports